import classSelectTrait from "./traits/classSelectTrait";
import contentTrait from "./traits/contentTrait";
import focalPointTrait from "./traits/focalPointTrait";
import mediaLibrarySelectTrait from "./traits/mediaLibrarySelectTrait";
import recursiveMenuTrait from "./traits/recursiveMenuTrait";
import selectizeTrait from "./traits/selectizeTrait";
import sizeWithUnitTrait from "./traits/sizeWithUnitTrait";
import sliderWithInputTrait from "./traits/sliderWithInputTrait";
import responsiveSizesTrait from "./traits/responsiveSizesTrait";
import svgIconEditorTrait from "./traits/svgIconEditorTrait";
import customTextArea from "./traits/textAreaTrait"
export default (editor, config = {}) => {
    classSelectTrait(editor);
    contentTrait(editor);
    focalPointTrait(editor);
    mediaLibrarySelectTrait(editor);
    recursiveMenuTrait(editor);
    selectizeTrait(editor);
    sizeWithUnitTrait(editor);
    sliderWithInputTrait(editor);
    responsiveSizesTrait(editor);
    svgIconEditorTrait(editor);
    customTextArea(editor);
};
